import React, { useContext } from "react";
import { Redirect, Route, useLocation } from "react-router-dom";
import { UserContext } from "../App";
import { verifyRight } from "../utils/users";

function DispatchMeRoute({
  children,
  prevPath,
  isPublic,
  driverApp,
  roles,
  component,
  driverComponent,
  subscriptionFree,
  object,
  objects,
  actions,
  adminOnly,
  ...props
}) {
  const { user, userInfos, loading } = useContext(UserContext);
  const location = useLocation();

  if (loading) return "";

  const redirectLogin = (
    <Route {...props}>
      <Redirect to={{ pathname: "/login", state: { prevPath } }} />
    </Route>
  );
  const redirectRoot = (
    <Route {...props}>
      <Redirect to={{ pathname: "/", state: { prevPath } }} />
    </Route>
  );
  const redirectSubscriptionForm = (
    <Route {...props}>
      <Redirect to={{ pathname: "/subscription", state: { prevPath } }} />
    </Route>
  );
  const redirectAccessNotGranted = (
    <Route {...props}>
      <Redirect to={{ pathname: "/access-not-granted", state: { prevPath } }} />
    </Route>
  );

  if (isPublic) return <Route {...props}>{component}</Route>;

  if (!user || !userInfos) return redirectLogin;

  if (adminOnly && userInfos.createdBy) return redirectRoot;

  // region Subscription verification
  /** Show subscription form is set like so:
   * if user is main account user :
   * - if subscription form never shown
   * - if subscription not paid and try period not available
   *
   * if user is created by the main account user :
   * - never
   */
  if (userInfos.subscriptionInfos.showSubscriptionForm) {
    if (subscriptionFree) return <Route {...props}>{component}</Route>;
    else return redirectSubscriptionForm;
  }

  /** Shows when the user has no access
   * if user is main account user :
   * - never (shows subscription form instead)
   *
   * if user is created by the main account user :
   * - if user main account subscription not paid and try period not available
   */
  if (!userInfos.subscriptionInfos.access) {
    if (location.pathname === "/access-not-granted")
      return <Route {...props}>{component}</Route>;
    return redirectAccessNotGranted;
  }
  // endregion

  // Verify no right required
  if (!object || !actions || !actions?.length)
    return <Route {...props}>{component}</Route>;
  // else verify user has rights
  else {
    const hasAccess = objects?.length
      ? objects.some((obj) =>
          actions.some((action) => verifyRight(userInfos, obj.object, action))
        )
      : actions.some((action) => verifyRight(userInfos, object, action));

    if (hasAccess || location.pathname === "/") {
      return <Route {...props}>{component}</Route>;
    }
  }

  return redirectRoot;
}

export default DispatchMeRoute;
